import { useTranslator } from 'tradera-lang/translate';
import React from 'react';
import { Link } from 'react-router-dom';

export const SearchPagination = ({ pagination, onlyPreviousLink }) => {
    const { t } = useTranslator();
    if (!pagination.pageLinks.some(a => a)) {
        return null;
    }

    if (onlyPreviousLink) {
        return (
            <section className="search-pagination-top">
                {pagination.prev && (
                    <Link to={pagination.prev.href} rel="prev">
                        <i className="font-icon" />
                    </Link>
                )}
            </section>
        );
    }
    return (
        <section className="search-pagination-bottom">
            <section className="search-pagination-show-more d-md-none d-flex w-100 justify-center mt-3">
                {pagination.next && (
                    <Link
                        className="btn btn-primary secondary-action"
                        rel="next"
                        to={pagination.next.href}>
                        {t('searchResults_showMore')}
                    </Link>
                )}
            </section>

            <ul className="search-pagination-numbered plain-list">
                {pagination.prev && (
                    <li className="search-pagination-previous">
                        <Link to={pagination.prev.href} rel="prev">
                            {t('searchResults_paginationPrevious')}
                        </Link>
                    </li>
                )}
                {pagination.next && (
                    <li className="search-pagination-next">
                        <Link to={pagination.next.href} rel="next">
                            {t('searchResults_paginationNext')}
                        </Link>
                    </li>
                )}

                <li className="search-pagination-numbers plain-list">
                    <ul>
                        {pagination.pageLinks.map((link, i) => (
                            <li
                                className={`search-pagination-number ${link.cssClass}`}
                                rel={link.rel}
                                key={i}>
                                <Link to={link.href}>{link.textString}</Link>
                            </li>
                        ))}
                    </ul>
                </li>
            </ul>
        </section>
    );
};
